"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGears = require("@appfolio/react-gears");

var _reactBigCalendarApm = require("@appfolio/react-big-calendar-apm");

var _dateFns = require("date-fns");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var CustomAgenda = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomAgenda, _React$Component);

  var _super = _createSuper(CustomAgenda);

  function CustomAgenda() {
    var _this;

    _classCallCheck(this, CustomAgenda);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onClickAgendaView = function (item) {
      _this.props.onAgendaView(item);
    };

    _this.formatAgendaKeys = function (startDate) {
      if (!startDate) {
        return '';
      }

      var day = (0, _dateFns.format)(startDate, 'MMMM do');
      return day === (0, _dateFns.format)(new Date(), 'MMMM do') ? "Today, ".concat(day) : day;
    };

    _this.formatDateForCompare = function (date) {
      if (!date) {
        return '';
      }

      return (0, _dateFns.format)(date, 'YMMdd');
    };

    _this.inRange = function (event, date, startAccessor, endAccessor) {
      return event[startAccessor] < (0, _dateFns.endOfMonth)(date) && event[endAccessor] > (0, _dateFns.startOfMonth)(date);
    };

    return _this;
  }

  _createClass(CustomAgenda, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.agendaScrollTo) {
        var rowId = document.getElementById('scrollTo');

        if (!rowId) {
          rowId = document.querySelector('.scrollTarget:last-child');
        }

        if (rowId) {
          rowId.scrollIntoView({
            behavior: 'auto'
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var rowId = document.getElementById('scrollTo');

      if (rowId) {
        rowId.scrollIntoView({
          behavior: 'auto'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          startAccessor = _this$props.startAccessor,
          endAccessor = _this$props.endAccessor;
      var events = this.props.events;
      var cnt = 1;
      events = events.filter(function (event) {
        return _this2.inRange(event, _this2.props.date, startAccessor, endAccessor);
      }); //Sort events by date/time, title

      events.sort(function (a, b) {
        return a[startAccessor] - b[startAccessor];
      }); //Group events into days

      var groupedEvents = {};
      events.map(function (event) {
        var startDate = event[startAccessor];
        var endDate = event[endAccessor];

        var day = _this2.formatAgendaKeys(startDate);

        if (!Object.prototype.hasOwnProperty.call(groupedEvents, day)) {
          groupedEvents[day] = [];
        }

        event.time = event.allDay ? 'All Day' : "".concat((0, _dateFns.format)(startDate, 'hh:mma'), " - ").concat((0, _dateFns.format)(endDate, 'hh:mma'));
        event.index = cnt;
        groupedEvents[day].push(event);
        cnt += 1;
        return groupedEvents;
      }); //Sort events within each group

      Object.keys(groupedEvents).map(function (event) {
        return groupedEvents[event].sort(function (a, b) {
          return b.allDay - a.allDay || a[startAccessor] - b[startAccessor];
        });
      }); //Determine which item to scroll to

      var eventsList = [];
      var scrollTo = false;
      var scrollToMatched = false;
      Object.keys(groupedEvents).map(function (event) {
        var item = groupedEvents[event][0];

        if (_this2.formatDateForCompare(item[startAccessor]) >= _this2.formatDateForCompare(_this2.props.date) && !scrollToMatched) {
          scrollTo = true;
          scrollToMatched = true;
        } else {
          scrollTo = false;
        }

        return eventsList.push({
          date: event,
          items: groupedEvents[event],
          scrollTo: scrollTo
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "h-100 overflow-auto"
      }, eventsList.map(function (obj) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "scrollTarget",
          id: obj.scrollTo ? 'scrollTo' : ''
        }, /*#__PURE__*/_react["default"].createElement("header", {
          className: "d-flex align-items-center bg-secondary list-group-item"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "d-flex align-items-center me-3"
        }, obj.date)), /*#__PURE__*/_react["default"].createElement(_reactGears.ListGroup, {
          key: obj.date,
          className: "mb-3 list-group-striped"
        }, obj.items.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement(_reactGears.ListGroupItem, {
            key: item.index,
            action: true,
            onClick: function onClick() {
              return _this2.onClickAgendaView(item);
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "row"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-lg-2 col-6 mt-1 pe-lg-0"
          }, /*#__PURE__*/_react["default"].createElement(_reactGears.Label, {
            className: "text-muted"
          }, item.time, " ")), /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-lg-2 col-6 mt-1 pe-lg-2"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "py-0 px-2 m-0 mb-1 rounded d-inline-block alert fade show alert-".concat(item.eventTypeColor),
            role: "alert"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "d-flex align-items-start"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "w-100"
          }, " ", item.eventTypeDisplay, " ")))), /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-lg-8 col-12 mt-1 ps-lg-0"
          }, /*#__PURE__*/_react["default"].createElement(_reactGears.Label, {
            className: "d-block text-truncate"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "font-weight-bold pe-2"
          }, item.title), "   ", /*#__PURE__*/_react["default"].createElement("span", null, item.eventEntity)))));
        })));
      }), !events.length && /*#__PURE__*/_react["default"].createElement(_reactGears.Alert, {
        className: "mt-4"
      }, " No Agenda Items Found"));
    }
  }]);

  return CustomAgenda;
}(_react["default"].Component);

exports["default"] = CustomAgenda;
CustomAgenda.propTypes = {
  date: _propTypes["default"].instanceOf(Date),
  events: _propTypes["default"].array
};
CustomAgenda.defaultProps = {
  events: []
};

CustomAgenda.navigate = function (date, action) {
  switch (action) {
    case _reactBigCalendarApm.Navigate.PREVIOUS:
      return (0, _dateFns.subMonths)(date, 1);

    case _reactBigCalendarApm.Navigate.NEXT:
      return (0, _dateFns.addMonths)(date, 1);

    default:
      return date;
  }
};

CustomAgenda.range = function (date) {
  var start = (0, _dateFns.startOfMonth)(date);
  var end = (0, _dateFns.endOfMonth)(date);
  return {
    start: start,
    end: end
  };
};